import { render, staticRenderFns } from "./LivesImpactedInfoModal.vue?vue&type=template&id=4a6c61c9&"
import script from "./LivesImpactedInfoModal.vue?vue&type=script&lang=js&"
export * from "./LivesImpactedInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports